import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import settings from '@/utils/settings'

const Facebook = ({ url }) => {
  const ID = settings.facebook_app_id

  return (
    <li>
      <a
        className='facebook'
        href={`https://www.facebook.com/dialog/share?app_id=${ID}&href=${url}`}
        rel='noreferrer noopener'
        target='_blank'
      >
        <p>{"Facebook"}</p>
        <VisuallyHidden>
          <FormattedMessage id='purchase.share_this_ebook_on_facebook' />
        </VisuallyHidden>
      </a >
    </li>
  )
}

export default Facebook

Facebook.propTypes = { url: PropTypes.string.isRequired }
